import type { ReportDefinitionSummary } from './api';

type Status = ReportDefinitionSummary['status'];
type Tone = 'success' | 'neutral';

/** Como a situação de um relatório aparece: o rótulo do selo e o tom. */
export class ReportDefinitionStatus {
  private static readonly SHOWN: Record<Status, { label: string; tone: Tone }> = {
    active: { label: 'Ativo', tone: 'success' },
    paused: { label: 'Pausado', tone: 'neutral' },
  };

  static of(status: Status): { label: string; tone: Tone } {
    return ReportDefinitionStatus.SHOWN[status];
  }

}
